<script lang="ts">
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";

  export let request_store_key: StoresKey;
  export let buttonClass: string = 'btn-primary'; // Default to primary if not specified

  const { store, T } = getStoresContext(request_store_key);
</script>

{#if $store}
  <div class="map-button-wrapper">
    <a 
      href="#2d-svg-map"
      class="btn {buttonClass}" 
      type="button"
    >
      {$T('store.see-on-map')}
    </a>
  </div>
{/if}

<style lang="scss">
  .map-button-wrapper {
    width: 100%;
  }
</style> 